import { call, put, takeEvery } from 'redux-saga/effects'

import { RealtimeClient } from '../../utils'

import { getLiveRealtimeData } from './api'

let realtimeClient

function* subscribeToRealtimeUpdates(config, actionName) {
  const { realtime_url: realtimeUrl, realtime_channel: realtimeChannel } =
    config

  yield call(realtimeClient.connect, realtimeUrl)

  const sagaChannel = yield call(
    realtimeClient.subscribeThroughSagaChannel,
    `${realtimeChannel}/all_json`
  )

  yield takeEvery(sagaChannel, function* onRealtimeUpdate(realtimeData) {
    yield put({ type: actionName, realtimeData })
  })
}

function* fetchRealtimeWorker(actionName, liveId) {
  const config = yield call(getLiveRealtimeData, liveId)

  yield call(subscribeToRealtimeUpdates, config, actionName)
}

export default function* enableAudienceCommentsRealtime(actionName, liveId) {
  if (realtimeClient) {
    return
  }

  realtimeClient = new RealtimeClient()
  yield call(fetchRealtimeWorker, actionName, liveId)
}
